import Icon from "../components/Icon";
import styles from "./message.module.less";
import getComponentRootDom from "./getComponentRootDom";

export default function (options = {}) {
  const content = options.content || "";
  const type = options.type || "chenggong";
  const duration = options.duration || 3000;
  const container = options.container || document.body;

  const div = document.createElement("div");

  //设置弹出消息css

  const typeInfo = styles[`info-${type}`];
  div.className = `${styles.message} ${typeInfo}`;

  const icon = getComponentRootDom(Icon, { type });
  if (options.container) {
    container.style.position = "relative";
    container.appendChild(div);
  }
  container.appendChild(div);

  div.innerHTML = `<div class='info-icon'>${icon.outerHTML}</div><div class='info-content'>${content}</div>`;
  div.clientHeight;

  div.style.opacity = 1;
  div.style.transform = "translate(-50%,-50%)";

  setTimeout(() => {
    div.style.transform = "translate(-50%,-50%) translateY(-25px)";
    div.style.opacity = 0;
    div.addEventListener(
      "transitionend",
      function () {
        div.remove();
        options.callback && options.callback();
      },
      { once: true }
    );
  }, duration);
}
